<template>
	<div>
		<section class="complete-data text-xs-left mt-3">
			<label class="label-title"></label>
			<v-flex xs3>
				<v-switch
					hide-details
					label="Datos de la organización"
					color="success"
					class="input-switch"
					v-model="completeDataActive"
				>
				</v-switch>
			</v-flex>
			<v-layout row wrap v-if="completeDataActive">
				<v-flex xs12 md4 text-xs-left mb-2 mr-3>
					<input-text
						label
						label-text="Nombre Completo"
						placeholder="Nombre Completo"
						v-model="newCustomer.rzSocial"
					/>
					<span class="caption red--text"
						v-if="!$v.newCustomer.rzSocial.required">
						La razón social es requerida
					</span>
				</v-flex>
				<v-flex xs12 md2 text-xs-left mb-2 mr-3>
					<input-text
						label
						label-text="Nombre Comercial"
						placeholder="Nombre Comercial"
						v-model="newCustomer.tradename"
					/>
				</v-flex>
				<v-flex xs12 md2 text-xs-left mb-2 mr-3>
					<select-button
						autocomplete
						label
						labelText="Tipo de Cliente"
						itemText="name"
						itemValue="id"
						:items="channels"
						v-model="newCustomer.channelId"
						@input="getChannelsInformation"
					/>
					<span class="caption red--text"
						v-if="!$v.newCustomer.channelId.required">
						El tipo de cliente es requerido.
					</span>
				</v-flex>
				<v-flex xs12 md2>
					<select-button
						autocomplete
						label-text="Seleccione Canal"
						item-text="name"
						item-value="id"
						:items="specificsChannels"
						v-model="channelInformationsId"
					/>
				</v-flex>
				<v-flex xs12 md2 text-xs-left mb-2 mr-3>
					<input-text
						label
						label-text="Ruc"
						placeholder="Ruc"
						v-model="newCustomer.numDocument"
					/>
					<span class="caption red--text"
						v-if="!$v.newCustomer.numDocument.required">
						El número de documento es requerido.
					</span>
				</v-flex>
				<v-flex xs2 text-xs-left mb-2 mr-3>
					<input-text
						label
						label-text="Rubro"
						placeholder="Rubro"
						v-model="newCustomer.category"
					/>
				</v-flex>
				<v-flex xs2 text-xs-left mb-2 mr-3>
					<input-text
						label
						label-text="Correo"
						placeholder="Correo"
						type="email"
						v-model="newCustomer.email"
					/>
				</v-flex>
				<v-flex xs2 text-xs-left mb-2 mr-3>
					<input-text
						label
						label-text="Teléfono"
						placeholder="Teléfono"
						type="tel"
						v-model="newCustomer.phone"
					/>
				</v-flex>
				<v-flex xs2 text-xs-left mb-2 mr-3>
					<input-text
						label
						label-text="Celular"
						placeholder="Celular"
						type="tel"
						v-model="newCustomer.movil"
					/>
				</v-flex>
				<v-flex xs2 text-xs-left mb-2 mr-3>
					<select-button
						autocomplete
						label
						labelText="Vendedor"
						itemText="name"
						itemValue="id"
						:items="sellers"
						v-model="newCustomer.employeeId"
					/>
					<span class="caption red--text"
						v-if="!$v.newCustomer.employeeId.required">
						El Vendedor es requerido.
					</span>
				</v-flex>
				<v-flex xs2 text-xs-left mb-2 mr-3>
					<select-date
						label
						labelText="Aniversario"
						v-model="newCustomer.anniversaryDate"
					/>
				</v-flex>
				<v-flex xs2 text-xs-left mb-2 mr-3>
					<select-date
						label
						labelText="Cumpleaños"
						v-model="newCustomer.dateBirth"
					/>
				</v-flex>
				<v-flex xs2 text-xs-left mb-2 mr-3>
					<select-button
						autocomplete
						label
						labelText="País"
						itemText="name"
						itemValue="id"
						:items="countries"
						v-model="newCustomer.country"
						@input="filterCities"
					/>
				</v-flex>
				<v-flex xs2 text-xs-left mb-2 mr-3>
					<select-button
						autocomplete
						label
						labelText="Ciudad"
						itemText="province"
						itemValue="id"
						:items="cities"
						v-model="newCustomer.city"
					/>
				</v-flex>
				<v-flex xs12 text-xs-left mb-2 mr-3>
					<input-text
						label
						label-text="Dirección"
						placeholder="Dirección"
						v-model="newCustomer.address"
					/>
				</v-flex>
			</v-layout>
		</section>
		<hr class="section-spacer"/>
		<section class="contact-data text-xs-left mt-3">
			<v-flex xs3>
				<v-switch
					hide-details
					label="Datos del contacto"
					color="success"
					class="input-switch"
					v-model="contactDataActive"
				>
				</v-switch>
			</v-flex>
			<v-layout row wrap v-if="contactDataActive">
				<v-flex xs2 text-xs-left mb-2 mr-3>
					<input-text
						label
						label-text="Nombre"
						placeholder="Nombre"
						:value="newContact.name"
					/>
				</v-flex>
				<v-flex xs2 text-xs-left mb-2 mr-3>
					<input-text
						label
						label-text="Apellido"
						placeholder="Apellido"
						v-model="newContact.lastname"
					/>
				</v-flex>
				<v-flex xs2 text-xs-left mb-2 mr-3>
					<select-date
						label
						labelText="Fecha de Nacimiento"
						v-model="newContact.dateBirth"
					/>
				</v-flex>
				<v-flex xs2 text-xs-left mb-2 mr-3>
					<select-button
						autocomplete
						label
						labelText="País"
						itemText="name"
						itemValue="name"
						:items="countries"
						v-model="newContact.countryId"
					/>
				</v-flex>
				<v-flex xs2 text-xs-left mb-2 mr-3>
					<select-button
						label
						labelText="Género"
						itemText="name"
						itemValue="id"
						:items="genders"
						v-model="newContact.gender"
					/>
				</v-flex>
				<v-flex xs2 text-xs-left mb-2 mr-3>
					<select-button
						label
						labelText="Estado Civil"
						itemText="name"
						itemValue="name"
						:items="civilStatus"
						v-model="newContact.civilStatus"
					/>
				</v-flex>
				<v-flex xs2 text-xs-left mb-2 mr-3>
					<input-text
						label
						label-text="Correo eletrónico"
						placeholder="Correo eletrónico"
						type="email"
						v-model="newContact.email"
					/>
				</v-flex>
				<v-flex xs2 text-xs-left mb-2 mr-3>
					<type-document-component
						label
						labelText="Tipo de identificación"
						placeholder="Tipo de identificación"
						v-model="newContact.numDocument"
						@input="getCustomer"
						@customerDetail="typeDocument"
						@customer-error="getCustomerError"
					/>
				</v-flex>
				<v-flex xs2 text-xs-left mb-2 mr-3>
					<input-text
						label
						label-text="Niños"
						placeholder="Niños"
						v-model="newContact.childrens"
					/>
				</v-flex>
				<v-flex xs2 text-xs-left mb-2 mr-3>
					<input-text
						label
						label-text="Bebes"
						placeholder="Bebes"
						v-model="newContact.babies"
					/>
				</v-flex>
				<v-flex xs2 text-xs-left mb-2 mr-3>
					<input-text
						label
						label-text="Teléfono"
						placeholder="Teléfono"
						type="tel"
						v-model="newContact.phone"
					/>
				</v-flex>
				<v-flex xs2 text-xs-left mb-2 mr-3>
					<input-text
						label
						label-text="Facebook"
						placeholder="Facebook"
						v-model="newContact.facebook"
					/>
				</v-flex>
				<v-flex xs2 text-xs-left mb-2 mr-3>
					<input-text
						label
						label-text="Twitter"
						placeholder="Twitter"
						v-model="newContact.twitter"
					/>
				</v-flex>
				<v-flex xs2 text-xs-left mb-2 mr-3>
					<input-text
						label
						label-text="Instagram"
						placeholder="Instagram"
						v-model="newContact.instagram"
					/>
				</v-flex>
				<v-flex xs12 text-xs-left mb-2 mr-3>
					<input-text
						label
						label-text="Dirección"
						placeholder="Dirección"
						v-model="newContact.address"
					/>
				</v-flex>
			</v-layout>
		</section>
		<hr class="section-spacer"/>
		<section class="rate text-xs-left mt-3">
			<label class="label-title">Tarifa</label>
			<rate-component 
				class="rate-component"
				:alreadyExistRate="!!customerInfo.id"
				:rates="rateAvailability"
				@rate-event="getRate"
			/>
		</section>
		<hr class="section-spacer"/>
		<section class="loyalty text-xs-left mt-3">
			<label class="label-title">Loyalty</label>
			<v-layout row>
				<v-flex xs2 text-xs-left mb-2 mr-3>
					<input-text
						label
						label-text="Puntos"
						placeholder="Puntos"
						v-model="loyalty.points"
					/>
				</v-flex>
			</v-layout>
		</section>
		<hr class="section-spacer"/>
		<section class="credit text-xs-left mt-3">
			<label class="label-title">Crédito</label>
			<v-layout row>
				<v-flex xs2 text-xs-left mb-2 mr-3>
					<input-text
						label-text="Día"
						placeholder="Día"
						v-model="credit.days"
					/>
				</v-flex>
				<v-flex xs2 text-xs-left mb-2 mr-3>
						<select-date
							labelText="Fecha Aprobada"
							icon="event"
							v-model="credit.date"
						/>
				</v-flex>
			</v-layout>
			<v-layout row mt-3>
				<v-flex xs2 d-flex justify-start>
					<v-btn
						class="btn-action btn-save white--text"
						@click="saveCustomer"
						:disabled="$v.$invalid"
					>
						Guardar
					</v-btn>
				</v-flex>
			</v-layout>
		</section>
	</div>
</template>

<script>
import { format } from 'date-fns';
import { required } from 'vuelidate/lib/validators';
import lib from '@/shared/lib';
import mixin from '@/shared/mixins';
import rateComponent from './Rate-component';
import inputText from './../../shared/input-text';
import selectButton from './../../shared/select-button';
import typeDocumentComponent from './../../shared/type-document-input';
import selectDate from './../../shared/select-date';

const {
	compose,
	setNewProperty,
} = lib;

function created() {
	if (this.customerInfo.id) {
		this.loadCustomerInfo(this.customerInfo);
	}
	this.loadData();
	this.getChannelsInformation();
}

function typeDocument(value) {
	this.newContact.numDocument = value;
}

async function loadData() {
	const requests = [
		this.$http.get(`${process.env.PMS_URL}/channels`),
		this.$http.get(`${process.env.PMS_URL}/sellers`),
		this.$http.get(`${process.env.PMS_URL}/countries`),
		this.$http.get(`${process.env.PMS_URL}/cities`),
	];
	const [
		{ data: channels },
		{ data: sellers },
		{ data: countries },
		{ data: cities },
	] = await Promise.all(requests);
	this.channels = channels.data;
	this.sellers = sellers.data;
	this.countries = countries.data;
	this.cities = cities.data;
}

function loadCustomerInfo(customer) {
	this.newCustomer = {
		address: customer.address,
		anniversaryDate: format(customer.anniversaryDate, 'YYYY-MM-DD'),
		category: customer.category,
		dateBirth: customer.dateBirth,
		city: customer.city && customer.city.data ? customer.city.data.id : null,
		country: customer.country && customer.country.data ? customer.country.data.id : null,
		email: customer.email,
		phone: customer.phone,
		movil: customer.cellPhone,
		numDocument: customer.numDocument,
		rzSocial: customer.rzSocial,
		tradename: customer.tradename,
		employeeId: customer.employee && customer.employee.data ? customer.employee.data.id : null,
		channelId: customer.channel && customer.channel.data ? customer.channel.data.id : null,
	};
	this.credit.days = customer.creditDays;
	this.loyalty.points = customer.loyaltyPoints;
	if (customer.rateAvailability) {
		this.rateAvailability = [...customer.rateAvailability];
	}
	if (customer.contacts) {
		this.contact = this.loadContactInfo(customer.contacts);
	}
}

function loadContactInfo(contacts) {
	this.newContact = {
		name: contacts.name || '',
		email: contacts.email || '',
		address: contacts.address || '',
		gender: contacts.gender || '',
		lastname: contacts.lastname || '',
		dateBirth: contacts.dateBirth || '',
		civilStatus: contacts.civilStatus || '',
		phone: contacts.phone || '',
		facebook: contacts.facebook || '',
		instagram: contacts.instagram || '',
		twitter: contacts.twitter || '',
		countryId: contacts.countryId || '',
		childrens: contacts.childrens || '',
		babies: contacts.babies || '',
		numDocument: contacts.numDocument || '',
	};
}

function buildContact(contact) {
	return compose(
		setNewProperty('name', contact.name || ''),
		setNewProperty('lastname', contact.lastname || ''),
		setNewProperty('email', contact.email || ''),
		setNewProperty('civilStatus', contact.civilStatus),
		setNewProperty('dateBirth', contact.dateBirth || ''),
		setNewProperty('address', contact.address || ''),
		setNewProperty('gender', contact.gender),
		setNewProperty('phone', contact.phone || ''),
		setNewProperty('facebook', contact.facebook || ''),
		setNewProperty('instagram', contact.instagram || ''),
		setNewProperty('twitter', contact.twitter || ''),
		setNewProperty('childrens', contact.childrens || ''),
		setNewProperty('babies', contact.babies || ''),
		setNewProperty('countryId', contact.countryId || ''),
		setNewProperty('documentType', contact.documentType),
		setNewProperty('numDocument', contact.numDocument || ''),
	)({});
}

function buildHeader(customer, credit, loyalty, channelInformationsId) {
	return compose(
		setNewProperty('rzSocial', customer.rzSocial),
		setNewProperty('tradename', customer.tradename),
		setNewProperty('numDocument', customer.numDocument),
		setNewProperty('email', customer.email),
		setNewProperty('civilStatus', null),
		setNewProperty('dateBirth', customer.dateBirth),
		setNewProperty('anniversaryDate', customer.anniversaryDate),
		setNewProperty('address', customer.address),
		setNewProperty('gender', null),
		setNewProperty('countryId', customer.country),
		setNewProperty('cityId', customer.city),
		setNewProperty('channelId', customer.channelId),
		setNewProperty('category', customer.category),
		setNewProperty('phone', customer.phone),
		setNewProperty('cellPhone', customer.movil),
		setNewProperty('employeeId', customer.employeeId),
		setNewProperty('creditDays', credit.days),
		setNewProperty('loyaltyPoints', loyalty.points),
		setNewProperty('channelInformationsId', channelInformationsId),
	)({});
}

function buildBody(customer, contact, rateAvailability, credit, loyalty, channelInformationsId) {
	const contactBody = this.buildContact(contact);
	const headerBody = this.buildHeader(
		customer,
		credit,
		loyalty,
		channelInformationsId,
	);
	return compose(
		setNewProperty('contacts', contactBody),
		setNewProperty('rateAvailability', rateAvailability),
	)(headerBody);
}

function mounted() {
	this.saveCustomer();
	this.filterCities();
	this.selectDate();
}

async function saveCustomer() {
	const url = `${process.env.PMS_URL}/customers-commercial-type`;
	const body = this.buildBody(
		this.newCustomer,
		this.newContact,
		this.rateAvailability,
		this.credit,
		this.loyalty,
		this.channelInformationsId,
		this.getRate,
	);
	try {
		await this.$http.post(url, body);
		this.showNotification('Cliente registrado con éxito', 'success');
		this.$router.push({ name: 'customers-list' });
	} catch (error) {
		this.showNotification('Información incompleta, cliente no registrado.', 'error');
	}
}

async function filterCities(country) {
	if (country) {
		const url = `${process.env.PMS_URL}/cities`;
		const params = { countryId: country };
		const { data: cities } = await this.$http.get(url, { params });
		this.cities = cities.data;
	}
}

function getCustomer(customer) {
	this.contacts.identity = customer;
}

function getCustomerError(num, doc) {
	const identity = {
		numDocument: num,
		documentType: doc,
	};
	this.contact.identity = identity;
}

function getRate(rate) {
	this.rateAvailability = [...rate];
}

function validations() {
	return {
		newCustomer: {
			channelId: { required },
			employeeId: { required },
			numDocument: { required },
			rzSocial: { required },
		},
	};
}

async function getChannelsInformation(cha) {
	const url = `${process.env.PMS_URL}/enterprise`;
	const params = { channelId: cha };
	const { data: response } = await this.$http.get(url, { params });
	this.specificsChannels = response.data;
	if (this.customerInfo.id) {
		this.channelInformationsId = this.customerInfo.channelInformationsId;
	}
}

function data() {
	return {
		channels: [],
		cities: [],
		mounted,
		channelInformationsId: 0,
		civilStatus: [
			{ id: 1, name: 'Soltero(a)' },
			{ id: 2, name: 'Casado(a)' },
			{ id: 3, name: 'Viudo(a)' },
			{ id: 4, name: 'Divorciado(a)' },
		],
		newContact: {
			address: '',
			babies: 0,
			dateBirth: '',
			childrens: null,
			civilStatus: '',
			countryId: '',
			numDocument: '',
			email: '',
			facebook: '',
			gender: '',
			phone: '',
			instagram: '',
			lastname: '',
			name: '',
			twitter: '',
		},
		contactDataActive: true,
		completeDataActive: true,
		countries: [],
		credit: {
			days: '',
			date: '',
		},
		creditMenuStart: false,
		sellers: [],
		genders: [
			{ id: 1, name: 'Hombre' },
			{ id: 2, name: 'Mujer' },
		],
		loyalty: {
			date: '',
			points: '',
		},
		loyaltyMenuStart: false,
		newCustomer: {
			address: '',
			anniversaryDate: '',
			dateBirth: '',
			city: '',
			country: '',
			email: '',
			tradename: '',
			category: '',
			movil: '',
			phone: '',
			responsable: '',
			numDocument: '',
			rzSocial: '',
			employeeId: '',
			channelId: '',
		},
		rateAvailability: [],
		specificsChannels: [],
	};
}

export default {
	name: 'customer-details',
	data,
	components: {
		inputText,
		rateComponent,
		selectButton,
		selectDate,
		typeDocumentComponent,
	},
	created,
	methods: {
		typeDocument,
		buildBody,
		buildContact,
		buildHeader,
		filterCities,
		getChannelsInformation,
		getCustomer,
		getCustomerError,
		getRate,
		loadContactInfo,
		loadCustomerInfo,
		loadData,
		saveCustomer,
	},
	mixins: mixin,
	props: {
		customerInfo: {
			default: () => {},
			type: Object,
		},
	},
	validations,
};
</script>

<style lang="scss" scoped>

.label-form {
	font-family: map-get($fonts, medium);
}

.rate-component {
	margin: 10px 0 20px;
}
</style>



// WEBPACK FOOTER //
// Customer-Details.vue?0c4e6a57